import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2 14v-4a2 2 0 0 1 2-2h2.172a2 2 0 0 0 1.414-.586l2.853-2.853C11.384 3.616 13 4.285 13 5.62v12.76c0 1.336-1.616 2.005-2.56 1.06l-2.854-2.853A2 2 0 0 0 6.172 16H4a2 2 0 0 1-2-2m19.707-3.293a1 1 0 0 0-1.414-1.414L19 10.586l-1.293-1.293a1 1 0 1 0-1.414 1.414L17.586 12l-1.293 1.293a1 1 0 0 0 1.414 1.414L19 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L20.414 12z"
    }
  )
);
var SvgSoundOffFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundOffFilled_default = SvgSoundOffFilled;

export { SoundOffFilled_default as default };
